import React, { useState } from "react";
import FavoriteBorderRoundedIcon from "@material-ui/icons/FavoriteBorderRounded";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  addFavoriteProduct,
  removeFavoriteProduct,
} from "../../../store/actions/auth";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";

const FavoriteProductIcon = ({ productId }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const language = useSelector((state) => state.store.language);
  const [loading, setLoading] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const checkIfProductIsFavorite = auth.user.favorite_products.find(
    (product) => product.product__id === productId
  );
  const handleClose = () => {
    setAlertOpen(false);
  };
  const handleOpen = () => {
    setAlertOpen(true);
    setLoading(false);
  };
  const snackBarText =
    language === "english"
      ? !checkIfProductIsFavorite
        ? "Product removed from favorites"
        : "Product added to favorites"
      : !checkIfProductIsFavorite
      ? "تمت إزالة المنتج من قائمة المفضلة"
      : "تمت إضافة المنتج إلى قائمة المفضلة";

  if (!auth.user) {
    return null;
  }
  return (
    <div>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <MuiAlert
          onClose={handleClose}
          severity={checkIfProductIsFavorite ? "success" : "warning"}
        >
          {snackBarText}
        </MuiAlert>
      </Snackbar>

      <Button
        variant="contained"
        size="small"
        disabled={loading}
        style={{
          backgroundColor: "rgba(255,255,255,0.7)",
          boxShadow: "none",
        }}
        onClick={(e) => {
          setLoading(true);
          e.preventDefault();
          !checkIfProductIsFavorite
            ? dispatch(
                addFavoriteProduct(productId, auth.user.user_id, handleOpen)
              )
            : dispatch(removeFavoriteProduct(productId, handleOpen));
        }}
      >
        {loading ? (
          <CircularProgress style={{ width: 20, height: 20 }} />
        ) : !checkIfProductIsFavorite ? (
          <FavoriteBorderRoundedIcon
            focusable={false}
            aria-hidden={true}
            style={{
              fontSize: 26,
              color: "#424242",
            }}
          />
        ) : (
          <FavoriteRoundedIcon
            style={{
              fontSize: 26,
              color: "#eb2f06",
            }}
          />
        )}
      </Button>
    </div>
  );
};

export default FavoriteProductIcon;
